import { api } from '../core';

interface AddToLightBundlePageData {
  documentName: string;
  documentLength: number;
  originalPageNumber: number;
  pageDimensions: {
    width: number;
    height: number;
  };
  inLightBundle: boolean;
  pageUri: string;
  thumbnailUri: string;
}

interface AddToLightBundleResponse {
  pages: Record<string, AddToLightBundlePageData>;
}

interface AddToLightBundleProps {
  bundleId: string;
  abortController?: AbortController;
  pageIds: string[];
}

const addToLightBundleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addToLightBundle: builder.mutation<AddToLightBundleResponse, AddToLightBundleProps>({
      query: ({ bundleId, abortController = new AbortController(), pageIds }: AddToLightBundleProps) => ({
        url: 'bundle/add-to-light',
        method: 'POST',
        signal: abortController.signal,
        body: {
          bundleId: bundleId,
          pageIds: pageIds,
        },
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in addToLightBundle in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useAddToLightBundleMutation } = addToLightBundleApi;
